export default "__VITE_ASSET__D8tQr7AK__"